webpackJsonp([70144966829960],{

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _components = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _components.PageWrapper,
	    { title: 'Contact Information' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'script',
	        { type: 'text/javascript' },
	        '\n          /*<![CDATA[*/\n          window.zE||(function(e,t,s){var n=window.zE=window.zEmbed=function(){n._.push(arguments)}, a=n.s=e.createElement(t),r=e.getElementsByTagName(t)[0];n.set=function(e){ n.set._.push(e)},n._=[],n.set._=[],a.async=true,a.setAttribute("charset","utf-8"), a.src="https://static.zdassets.com/ekr/asset_composer.js?key="+s, n.t=+new Date,a.type="text/javascript",r.parentNode.insertBefore(a,r)})(document,"script","9127a396-c5aa-46e4-addf-c06d61c32232");\n          /*]]>*/\n        '
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'contentPage' },
	      _react2.default.createElement(_components.ContactForm, { supportEmail: data.site.siteMetadata.supportEmail })
	    )
	  );
	};
	
	exports.default = ContactPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-92e5f72791d923d9f624.js